import { PageHeader } from '@my/ui';
import { BarChart3, Clock, LineChart, Map, PieChart, TrendingUp, Truck, Users } from 'lucide-react';

const UPCOMING = [
  {
    icon: TrendingUp,
    title: 'Order Performance',
    description: 'On-time delivery rates, lead times, and order volume trends over time.',
  },
  {
    icon: Truck,
    title: 'Fleet Utilisation',
    description: 'Vehicle and driver utilisation rates, idle time, and capacity planning.',
  },
  {
    icon: BarChart3,
    title: 'Revenue & Cost',
    description: 'Revenue per route, cost per km, and margin analysis by customer.',
  },
  {
    icon: Map,
    title: 'Route Intelligence',
    description: 'Heat maps, corridor analysis, and route efficiency scoring.',
  },
  {
    icon: Users,
    title: 'Customer Insights',
    description: 'Shipment frequency, top customers, and service-level compliance.',
  },
  {
    icon: PieChart,
    title: 'Cargo Mix',
    description: 'Breakdown by cargo type, weight bands, and load factor trends.',
  },
];

export default function AnalyticsPage() {
  return (
    <div className="flex h-full flex-col pl-2 pr-2">
      <PageHeader title="Analytics Dashboard" description="Monitor performance and utilization." />

      <main className="flex flex-1 flex-col items-center justify-center gap-10 py-10">
        {/* Hero */}
        <div className="flex max-w-lg flex-col items-center gap-4 text-center">
          <div className="relative flex items-center justify-center">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-slate-100">
              <LineChart className="h-10 w-10 text-slate-400" />
            </div>
            <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-blue-500">
              <Clock className="h-3 w-3 text-white" />
            </span>
          </div>

          <div className="space-y-2">
            <h2 className="text-2xl font-bold text-slate-700">Analytics coming soon</h2>
            <p className="text-sm leading-relaxed text-slate-500">
              We're building powerful insights directly into your TMS. Real-time dashboards and
              reports will appear here — no exports, no spreadsheets.
            </p>
          </div>

          <span className="inline-flex items-center gap-1.5 rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-xs font-medium text-blue-600">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-blue-500" />
            In development
          </span>
        </div>

        {/* Feature cards */}
        <div className="grid w-full max-w-3xl grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {UPCOMING.map(({ icon: Icon, title, description }) => (
            <div
              key={title}
              className="space-y-2 rounded-md border border-slate-200 bg-white p-4 opacity-60"
            >
              <div className="flex items-center gap-2">
                <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-slate-100">
                  <Icon className="h-4 w-4 text-slate-500" />
                </div>
                <span className="text-xs font-semibold text-slate-700">{title}</span>
              </div>
              <p className="text-[11px] leading-relaxed text-slate-400">{description}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
